import { FC, forwardRef, KeyboardEvent, MouseEvent, ReactElement } from 'react'

import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'

type Props = {
  onClick: (e?: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>) => void
  icon?: ReactElement
  text: string
  disabled?: boolean
}

/** Component to be used as a base for creating new CheckboxMenuItems. NOT for standalone use (eg. ActionDeleteItem) */
export const CheckboxMenuItem: FC<Props> = forwardRef<HTMLLIElement, Props>(
  ({ onClick, icon, text, disabled = false }, ref) => {
    return (
      <MenuItem onClick={onClick} ref={ref} disabled={disabled}>
        {icon && <ListItemIcon>{icon}</ListItemIcon>}
        <ListItemText>{text}</ListItemText>
      </MenuItem>
    )
  }
)

CheckboxMenuItem.displayName = 'CheckboxMenuItem'
